// extracted by mini-css-extract-plugin
export default {"iOS11TextBug":"t-c3ucyU"};